import { temAcesso } from '@/shared/auth/temAcesso'

const Itens = () => import('./Itens.vue')

export default {
    path: 'baseconhecimento',
    name: 'BaseConhecimento',
    component: Itens
}
